<ng-template #cartDetailsRef let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Cart Details</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<i class="fa fa-close"></i>
		</button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="col-12">
				<div class="table-responsive">
					<table class="table table-fixed table-striped table-hover table-fluid w-100" *ngIf="cartdetails.length">
						<thead class="thead-dark sticky-header">
							<tr>
								<th>Date Added</th>
								<th>Item</th>
								<th>Desc</th>
								<th>Qty</th>
								<th>Price</th>
								<th>Total</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let i of cartdetails">
								<td>{{ i.date_added }}</td>
								<td>{{ i.stockid }}</td>
								<td>{{ i.name }}</td>
								<td>{{ i.quantity }}</td>
								<td>{{ i.price | currency }}</td>
								<td>{{ i.price * i.quantity | currency }}</td>
							</tr>
						</tbody>
					</table>
					<h4 class="text-center mt-3" *ngIf="!cartdetails.length">No Items in Cart</h4>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>

<div class="tp-box w-100" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">login</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">{{ title }}</span>
				</div>
			</div>
			<div class="cw-body" *ngIf="viewing">
				<div class="table" *ngIf="viewing.length">
					<table class="table table-fixed table-sm table-fixed">
						<thead class="thead-dark sticky-header">
							<tr>
								<th class="sticky-header">Customer#</th>
								<th class="sticky-header">Name</th>
								<th class="sticky-header">Address1</th>
								<th class="sticky-header">Address2</th>
								<th class="sticky-header">Address3</th>
								<th class="sticky-header">Address4</th>
								<th class="sticky-header">Address5</th>
								<th class="sticky-header">Items</th>
								<th class="sticky-header">User</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let d of viewing" (click)="viewCart(d)">
								<td><a [routerLink]="'/customers/view/'+d.debtorno">{{ d.debtorno}}.{{ d.branchcode }}</a></td>
								<td>{{ d.brname}}</td>
								<td>{{ d.braddress1}}</td>
								<td>{{ d.braddress2}}</td>
								<td>{{ d.braddress3}}</td>
								<td>{{ d.braddress4}}</td>
								<td>{{ d.braddress5 }}</td>
								<td>{{ d.items }} ({{ d.qty }})</td>
								<td>{{ d.userid }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="p-4 text-center text-muted" *ngIf="!viewing.length">
					<h4>No carts found</h4>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				[title]="title"
				icon="shopping_cart"
				accent="danger"
				[value]="data ? data.length : null"
				[loading]="!data"
				[buckets]="cartBuckets"
				(bucketView)="onCartBucket($event)"
				(view)="toggleFlip(data, title)">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
